import {
  maxLengthValidationMessage,
  maxValidationMessage,
  minLengthValidationMessage,
  minValidationMessage,
} from "../helpers/validations-messages";
import { ConfigOption } from "@ngx-formly/core";
import { Validators } from "@angular/forms";
import { FormlyFieldNgSelect } from "../types/ngselect.type";
import { FormlyFieldNgInput } from "../types/nginput.type";
import { ModalInputComponent } from "../types/madal.input.type";
import { ModalWrapperComponent } from "../wrappers/modal.wrapper";
import { FormlyFieldFile } from "../types/upload.file.type";
import { fieldMatchValidator, validDateValidator } from "../helpers/validators";
import { Typologic } from "../types/typologic.type";
import { FormlyFieldHtmlEditor } from "../types/html-editor.type";

export const config: ConfigOption = {
  validationMessages: [
    { name: "required", message: "Questo campo è richiesto" },
    { name: "minLength", message: minLengthValidationMessage },
    { name: "maxLength", message: maxLengthValidationMessage },
    { name: "min", message: minValidationMessage },
    { name: "max", message: maxValidationMessage },
    { name: "maximumMoneyValidation", message: "dovrebbe essere 100" },
    { name: "email", message: "La stringa inserita non corrisponde ad una email" },
    { name: "password", message: "la password deve contenere almeno: un carattere speciale, 8 caratteri ed un numero" },
  ],
  wrappers: [
    { name: "modal", component: ModalWrapperComponent },
  ],
  types: [
    { name: "ngselect", component: FormlyFieldNgSelect },
    { name: 'html-editor', component: FormlyFieldHtmlEditor },
    { name: "typologic", component: Typologic },
    { name: "nginput", component: FormlyFieldNgInput },
    { name: "modal-input", component: ModalInputComponent },
    { name: "file", component: FormlyFieldFile, wrappers: ["form-field"] },
  ],
  validators: [
    { name: "email", validation: Validators.email },
    { name: "required", validation: Validators.required },
    { name: "password", validation: Validators.pattern("^(?=.*[A-Za-z0-9])(?=.*[^A-Za-z0-9]).{8,}$") },
    { name: "fieldMatch", validation: fieldMatchValidator },
    { name: 'validDate', validation: validDateValidator }
  ],
};
